import React from "react";
import classes from "./classes.module.scss";
import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import Form from "@Front/Components/DesignSystem/Form";
import TextField from "@Front/Components/DesignSystem/Form/TextField";
import Button, { EButtonVariant } from "@Front/Components/DesignSystem/Button";
import { ValidationError } from "class-validator";
import { useSiteTextContent } from "@Front/Stores/SiteTextsContext";
import SiteConfigDisplayNameLine from "@Front/Components/Layouts/Common/SiteConfigDisplayNameLine";

type IProps = {
	onSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: { [key: string]: string }) => void;
	validationErrors: ValidationError[];
	siteDisplayName: string | null;
};

export default function StepNewPassword(props: IProps): React.JSX.Element {
	const { onSubmit, validationErrors, siteDisplayName } = props;
	const formTitle = useSiteTextContent("login.stepNewPassword.title");
	const passwordPlaceholder = useSiteTextContent("login.form.newPassword.placeholder");
	const passwordHint = useSiteTextContent("login.form.password.hint");
	const confirmPlaceholder = useSiteTextContent("login.form.password.confirmPlaceholder");
	const submitCta = useSiteTextContent("login.form.submit.validate");

	return (
		<div className={classes["root"]}>
			<Typography typo={ETypo.DISPLAY_LARGE}>
				<div className={classes["title"]}>{formTitle}</div>
			</Typography>
			<SiteConfigDisplayNameLine siteDisplayName={siteDisplayName} />
			<Form className={classes["form"]} onSubmit={onSubmit}>
				<TextField
					placeholder={passwordPlaceholder}
					name="password"
					validationError={validationErrors.find((error) => error.property === "password")}
					password
				/>
				<Typography typo={ETypo.TEXT_SM_REGULAR} color={ETypoColor.COLOR_NEUTRAL_500} className={classes["password_indication"]}>
					{passwordHint}
				</Typography>
				<TextField
					placeholder={confirmPlaceholder}
					name="confirm_password"
					validationError={validationErrors.find((error) => error.property === "confirm_password")}
					password
				/>
				<Button type="submit" variant={EButtonVariant.PRIMARY} className={classes["submit_button"]}>
					{submitCta}
				</Button>
			</Form>
		</div>
	);
}
